import { render, staticRenderFns } from "./TargetCapacity.vue?vue&type=template&id=6473c26f&scoped=true"
import script from "./TargetCapacity.vue?vue&type=script&lang=js"
export * from "./TargetCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473c26f",
  null
  
)

export default component.exports